/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ColumnSettingScopeConstants = {
    ALL: 'ALL',
    WIDTH: 'WIDTH',
    PIN: 'PIN',
    POSITION: 'POSITION',
    UNIT: 'UNIT'
} as const;
export type ColumnSettingScopeConstants = typeof ColumnSettingScopeConstants[keyof typeof ColumnSettingScopeConstants];


export function ColumnSettingScopeConstantsFromJSON(json: any): ColumnSettingScopeConstants {
    return ColumnSettingScopeConstantsFromJSONTyped(json, false);
}

export function ColumnSettingScopeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnSettingScopeConstants {
    return json as ColumnSettingScopeConstants;
}

export function ColumnSettingScopeConstantsToJSON(value?: ColumnSettingScopeConstants | null): any {
    return value as any;
}

